import React from "react";
import "./PageContent.scss";

const PageContent = (props) => {
  return <div className="page-content">{props.children}</div>;
};

export default PageContent;
